import { render, staticRenderFns } from "./refund-info.vue?vue&type=template&id=c2db7928&scoped=true&"
import script from "./refund-info.vue?vue&type=script&lang=ts&"
export * from "./refund-info.vue?vue&type=script&lang=ts&"
import style0 from "./refund-info.vue?vue&type=style&index=0&id=c2db7928&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../16/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2db7928",
  null
  
)

export default component.exports